import { DivisionsFilterDto } from "app/shared/model/DiscountDto";

export const getSelectedDivisionIds = (state: any): number[] => {
  let ids: any = null;
  
  if (state?.divisions?.selectedDivisionIds !== undefined) {
    ids = state.divisions.selectedDivisionIds;
  }
  else if (state?.discountEditor?.divisions?.selectedDivisionIds !== undefined) {
    ids = state.discountEditor.divisions.selectedDivisionIds;
  }
  else if (state?.selectedDivisionIds !== undefined) {
    ids = state.selectedDivisionIds;
  }
  
  if (ids !== null && ids !== undefined) {
    if (Array.isArray(ids)) {
      const numericIds = ids
        .map((id: any) => {
          if (typeof id === 'number') return id;
          if (typeof id === 'string') {
            const num = Number(id);
            return isNaN(num) ? null : num;
          }
          return null;
        })
        .filter((id: any) => id !== null && !isNaN(id)) as number[];
      
      return numericIds;
    }
    if (typeof ids === 'number') {
      return [ids];
    }
    if (typeof ids === 'string') {
      const num = Number(ids);
      return isNaN(num) ? [] : [num];
    }
  }

  return [];
};

export function getDivisionsDto(state: any): DivisionsFilterDto {
  const selectedIds = getSelectedDivisionIds(state);
  const divisionId = selectedIds.length > 0 ? selectedIds[0] : 0;
  return {
    divisionId: divisionId
  };
}